(function () {
  // This file builds and displays the message that says we don't support IE anymore
  'use strict';

  function createElement(options) {
    const el = document.createElement(options.element);

    if (options.classList && options.classList.length) {
      for (let i = 0; i < options.classList.length; i++) {
        el.classList.add(options.classList[i]);
      }
    }

    if (options.attrs && options.attrs.length) {
      for (let i = 0; i < options.attrs.length; i++) {
        const attribute = options.attrs[i];
        el.setAttribute(attribute.name, attribute.value);
      }
    }

    if (options.innerHtml) {
      el.innerHTML = options.innerHtml;
    }

    return el;
  }

  if (/MSIE|Trident/.test(window.navigator.userAgent)) {
    const browsers = [
      {
        name: 'Microsoft Edge',
        url: 'https://www.microsoft.com/en-us/edge'
      },
      {
        name: 'Google Chrome',
        url: 'https://www.google.com/chrome/'
      },
      {
        name: 'Mozilla Firefox',
        url: 'https://www.mozilla.org/en-US/firefox/new/'
      }
    ];

    const body = document.querySelector('body');
    const outerContainer = createElement({
      element: 'div',
      classList: ['ie-display', 'tAlignCenter', 'pad20', 'absolute']
    });
    const innerContainer = createElement({
      element: 'div',
      classList: ['inner-container', 'tAlignCenter']
    });
    const logo = createElement({
      element: 'img',
      attrs: [{ name: 'src', value: '/assets/images/sc-logo-dark.svg' }],
      classList: ['logo']
    });
    const paragraph = createElement({
      element: 'p',
      innerHtml:
        'SimpleCitizen no longer supports Internet Explorer. Please download one of the supported browsers below to login.'
    });
    const ul = createElement({ element: 'ul' });

    for (let i = 0; i < browsers.length; i++) {
      const browser = browsers[i];
      const li = createElement({ element: 'li', classList: ['dInlineBlock'] });
      const a = createElement({
        element: 'a',
        attrs: [{ name: 'href', value: browser.url }],
        classList: ['height100', 'width100', 'dBlock', 'button', 'secondary'],
        innerHtml: browser.name
      });
      li.appendChild(a);
      ul.appendChild(li);
    }

    innerContainer.appendChild(logo);
    innerContainer.appendChild(paragraph);
    innerContainer.appendChild(ul);
    outerContainer.appendChild(innerContainer);
    body.appendChild(outerContainer);
  }
})();
